import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../Constants/ApiConstants";

let product_name=null
let status=null

const Products = () => {
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState(null)
  const [rowSelected, setRowSelected] = useState(null)
  const [displayDetailBox, setDisplayDetailBox] = useState(false)

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    const result = await axios.get(`${API_BASE_URL}/v1/product/list/active-inactive`);
    console.log("My Data:", result.data.data)
    setProducts(result.data.data.reverse());
  };

  const inActivateProduct = async id => {
    if(window.confirm('Are you sure?')){
      await axios.post(`${API_BASE_URL}/v1/product/inactivate/${id}`).then(response => { 
        console.log("Response:",response.data.message)
        toast.success(response.data.message);

    }).catch(error => {
        console.log(error.response.data.message)
        toast.error(error.response.data.message);
    });
    loadProducts()
    }
    
  };

  const ActivateProduct = async id => {
    if(window.confirm('Are you sure?')){
      await axios.post(`${API_BASE_URL}/v1/product/activate/${id}`).then(response => { 
        console.log("Response:",response.data.message)
        toast.success(response.data.message);

    }).catch(error => {
        console.log(error.response.data.message)
        toast.error(error.response.data.message);
    });
    loadProducts()
    }
    
  };

  const activateActions = (e, product) => {
    setDisplayDetailBox(false)
    setRowSelected(product.id)
    status=product.active
    product_name = product.name
  }

  const viewProduct = () => {
    const product = products.find(p => p.id === rowSelected)
    setProduct(product)
    setDisplayDetailBox(true)
  }

  return (
    <div className="w-full mt-12">
      <ToastContainer />
      <main className="w-full flex-grow p-6">
        <h1 className="text-3xl text-black pb-6">Products</h1>
        <div className="bg-white overflow-auto">
          <div className="flex justify start p-4">
            <div className="pr-3">
              <button
                type="button"
                className="bg-blue-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded"
                disabled={!rowSelected}
                onClick={viewProduct}
                data-modal-toggle="defaultModal">
                View
              </button>
            </div>
            <div className="pr-3">
              <Link to={`product/images/list/${rowSelected}/${product_name}`}><button className="bg-blue-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded" disabled={!rowSelected}>
                Images
              </button></Link>
            </div>
            {/* <div className="pr-3">
              <button className="bg-blue-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded" disabled={!rowSelected}>
                Update
              </button>
            </div> */}
            <div className="pr-5">
              <Link onClick={() => inActivateProduct(rowSelected)}>
                <button className="bg-blue-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded" disabled={!rowSelected  || status==null || status==false}>
                  Inactivate
                </button>
              </Link>
            </div>

            <div className="pr-5">
              <Link onClick={() => ActivateProduct(rowSelected)}>
                <button className="bg-blue-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded" disabled={!rowSelected || status==null || status==true}>
                  Activate
                </button>
              </Link>
            </div>

            <div className="pr-3">
              <Link to={`/product/create`}><button className="bg-green-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded">
                Create New
              </button></Link>
            </div>

            <div className="pr-3">
              <Link to={`/product/image/upload`}><button className="bg-green-700 disabled:bg-blue-300 text-white font-bold py-1 px-4 rounded">
                Upload Image
              </button></Link>
            </div>

          </div>
          {displayDetailBox &&
            <div className="flex justify start p-4">
              <div className="p-10 w-full bg-green-400">
                <h3 className="text-2xl text-white pb-6">Details:</h3>
                <h3 className="text-2xl text-black pb-6">{product.name}</h3>
                {product.images.length == 0 && <h1 className="text-2xl text-black pb-6">No Image Found</h1>}
                {product.images.length > 0 && <img src={product.images[0].link} alt="" width="200" height="300"></img>}
                <div className="mt-5"><button className="bg-blue-700 text-white font-bold py-1 px-4 rounded" onClick={e => { setDisplayDetailBox(false) }}>Close</button></div>

              </div>
            </div>

          }

          {products.length == 0 && <h1 className="text-2xl text-black pb-6">Loading...</h1>}
          {products.length > 0 && <table className="text-left w-full border-collapse">
            <thead>
              <tr>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">#</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Name</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Status</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr className="hover:bg-grey-lighter" key={index + 1}>
                  <td className="py-4 px-6 border-b border-grey-light">
                    <input checked={product.id === rowSelected} type="radio" onChange={e => { activateActions(e, product) }} />
                  </td>
                  <td className="py-4 px-6 border-b border-grey-light">{index + 1}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{product.name}</td>
                  <td className="py-4 px-6 border-b border-grey-light color">{product.active? "Active" : "Inactive"}</td>
                </tr>

              ))}
            </tbody>
          </table>}

        </div>
      </main>
    </div>
  )
}

export default Products
